/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _computeTreeData = _interopRequireDefault(require("./computeTreeData"));
var _editedTreeData = _interopRequireDefault(require("./tree/editedTreeData"));
var _useTreeColumn = _interopRequireDefault(require("./useTreeColumn"));
var _default = function _default(props, computedProps, computedPropsRef) {
  Object.assign(computedProps, (0, _useTreeColumn.default)(props, computedProps, computedPropsRef));
  var computedEditedTreeData = function computedEditedTreeData(editProps) {
    return (0, _editedTreeData.default)(editProps, computedPropsRef);
  };
  computedProps.computeTreeData = _computeTreeData.default;
  computedProps.editedTreeData = computedEditedTreeData;
};
exports.default = _default;